import Button from "../Button/Button";
import styles from "./InputFile.module.scss";

export interface FileItem {
  filePath: string;
  fileName: string;
  fileType: string;
  dataBlob: string;
}

export interface InputFileProps {
  addFiles?: (file: File[]) => void;
  setFile?: (file: FileItem) => void;
  label?: string;
    accept?: string;
    isError?: boolean;
}
export default function InputFile({
  setFile,
  label = "Choisir un fichier",
  addFiles,
  accept,
  isError,
}: InputFileProps) {
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log("File Change:", e.target.files);
  

    const filelist = e.target.files || [];

    const FileFormated: File[] = [];

    for (let i = 0; i < filelist.length; i++) {
      const file = filelist[i];
      FileFormated.push(file);
    }
    console.log("FileFormated:", FileFormated);
    if (addFiles) {
      addFiles(FileFormated);
    }

    /*
    if (file) {
      const filePath = URL.createObjectURL(file); // Crée un URL temporaire pour le fichier
      const fileName = file.name;
      const fileType = file.type;

      try {
        const result = await getDataFromUrlFile(filePath);
        console.log("Result:", result);
      } catch (err) {
        console.log("Error:", err);
      }

      const dataBlob = await getDataFromUrlFile(filePath);

      setFile &&
        setFile({
          filePath,
          fileName,
          fileType,
          dataBlob: dataBlob as string,
        });
    }
        */
  };
  return (
    <Button variant={ isError ?"red" :"gray"}>
      <label className={styles["label"]}>{label}</label>
      <input
        className={styles["input"]}
        type="file"
        onChange={handleFileChange}
        accept={accept}
        
      />
    </Button>
  );
}
